import { useRef, useState } from 'react';

export const useClickCounter = (threshold: number, callback: () => void, resetDelay: number = 3000) => {
  const [count, setCount] = useState(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleClick = () => {
    const newCount = count + 1;
    setCount(newCount);

    // Clear previous timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (newCount >= threshold) {
      callback();
      setCount(0);
    } else {
      // Reset counter after delay
      timeoutRef.current = setTimeout(() => {
        setCount(0);
      }, resetDelay);
    }
  };

  return { count, handleClick };
};
